import { styled } from '@mui/material';

export const StyledInputs = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    '.MuiTextField-root, .file-field': { maxWidth: '47%' },
  },
  [theme.breakpoints.up('md')]: {
    '.MuiTextField-root, .file-field': { maxWidth: '48%' },
  },
  '.file-field .MuiTextField-root': { maxWidth: '100%' },
}));

export const StyledField = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    '.MuiTextField-root, .file-field': { maxWidth: '97.7%' },
  },
  [theme.breakpoints.up('md')]: {
    '.MuiTextField-root, .file-field': { maxWidth: '100%' },
  },
}));
